import React from "react";
import DonationForm from "./Component/DonationForm";
import { useLocation } from "react-router-dom";
import BackButton from "../../Components/BackButton";
import useTranslation from "../../utils/i18n/useTranslation";

const EditDonation = ({ collection }) => {
  const { state } = useLocation();
  const { t } = useTranslation();
  return (
    <>
      {" "}
      {collection?.collection === "donation" ||
        (collection === "donation" && (
          <BackButton title={t("editDonationTitle")} />
        ))}
      <DonationForm collection={collection} isEdit={true} editData={state} />
    </>
  );
};

export default EditDonation;
